export const isIpad = (): boolean => {
  const { userAgent, vendor } = navigator;
  // From iOS13 userAgent string is same for Mac and iPad, so we need to check if it's touch device too
  return (
    userAgent.includes('Mac') &&
    'ontouchend' in document &&
    !userAgent.toLowerCase().match(/Mobile|iPhone/gi) &&
    // is Apple and not Chrom simulator for e.g.
    vendor.includes('Apple')
  );
};
export default isIpad;
